import * as React from 'react';

// @TODO - create folder like containers/features/audio-calls
// import { LandingContainer } from 'containers/landing/landing-container';

const Page: React.FunctionComponent = () => {
  // return <LandingContainer />;
  return <>{'Index'}</>;
};

export default Page;

export { getServerSideProps } from 'lib/get-server-side-props';
